import { render, staticRenderFns } from "./EditDid.vue?vue&type=template&id=a06672b6&scoped=true&"
import script from "./EditDid.vue?vue&type=script&lang=js&"
export * from "./EditDid.vue?vue&type=script&lang=js&"
import style0 from "./EditDid.vue?vue&type=style&index=0&id=a06672b6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a06672b6",
  null
  
)

component.options.__file = "EditDid.vue"
export default component.exports